import { render } from "./CreateTestForm.vue?vue&type=template&id=14e6dd55&scoped=true"
import script from "./CreateTestForm.vue?vue&type=script&lang=js"
export * from "./CreateTestForm.vue?vue&type=script&lang=js"

import "./CreateTestForm.vue?vue&type=style&index=0&id=14e6dd55&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e6dd55"]])

export default __exports__